import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AxeptioService {

  constructor() {
    const head = document.getElementsByTagName('head')[0];
    const script: HTMLScriptElement = document.createElement('script');
    script.innerHTML = `
      window.axeptioSettings = { clientId: "62444e8bc14d350052c779ac", cookiesVersion: "playbacpress-fr"};
      (function (d, s) {
        var t = d.getElementsByTagName(s)[0],
          e = d.createElement(s);
        e.async = true;
        e.src = "//static.axept.io/sdk.js";
        t.parentNode.insertBefore(e, t);
      })(document, "script");
    `;

    head.appendChild(script);
  }
}
